import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import { AiOutlinePrinter } from "react-icons/ai";

import DatePicker from "../../components/DatePicker";
import NoData from "../../components/Nodata";

import useStore from "../../store";

import api from "../../services/api";

export default () => {
  const [changelogs, setChangelogs] = useState();
  const [filters, setFilters] = useState({
    startDate: new Date().setMonth(new Date().getMonth() - 1),
    endDate: new Date(),
  });

  const { user } = useStore();

  useEffect(() => {
    getChangelogs();
  }, [filters]);

  const getChangelogs = async (e) => {
    try {
      const { data } = await api.post("change_log/search", filters);
      setChangelogs(data.change_logs);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (changelog) => {
    try {
      if (!window.confirm("Are you sure ?")) return;
      const { data } = await api.remove(`change_log&id=${changelog.id}`);
      await getChangelogs();
      toast.success("Successfully deleted !");
    } catch (e) {
      console.log(e);
    }
  };

  if (!changelogs) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-5">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Change logs</h1>
        <button
          title="Print all changelogs"
          onClick={() => window.print()}
          className="print:hidden cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded flex items-center disabled:cursor-progress"
        >
          <AiOutlinePrinter className="text-xl mr-2" />
          <span className="text-sm">Print</span>
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4 my-4 print:hidden">
        <input
          type="search"
          placeholder="Search by user"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          required
        />

        <DatePicker
          value={filters.startDate}
          onChange={(startDate) => setFilters({ ...filters, startDate })}
        />
        <DatePicker
          value={filters.endDate}
          onChange={(endDate) => setFilters({ ...filters, endDate })}
        />
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6">
        <table className="w-full text-left border-collapse my-5">
          <thead className="text-sm text-gray-400 border-b">
            <tr>
              <th className="py-2">Entity</th>
              <th className="py-2">Field(s)</th>
              <th className="py-2">Changed By</th>
              <th className="py-2">Date</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {changelogs.map((changelog) => (
              <tr
                className="hover:bg-gray-50 border-b"
                // onClick={() => navigate(`/changelog/${changelog.id}`)}
              >
                <td className="p-2 py-3">{changelog.table_name}</td>
                <td className="p-2 py-3">
                  <CompareObjects changelog={changelog} />
                </td>
                <td className="p-2 py-3">{changelog.created_by || "admin"}</td>
                <td className="p-2 py-3">
                  {new Date(changelog.changed_at).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!changelogs?.length && <NoData />}
      </div>
    </div>
  );
};

const CompareObjects = ({ changelog }) => {
  let changes = {};

  const obj1 = JSON.parse(changelog.old_data);
  const obj2 = JSON.parse(changelog.new_data);

  for (let key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
        changes[key] = { from: obj1[key], to: obj2[key] };
      }
    }
  }

  return (
    <ul className="text-gray-600">
      {Object.entries(changes).map(([key, { from, to }]) => (
        <li key={key} className="mb-1">
          <strong className="text-gray-800">{key}:</strong> changed from{" "}
          <strong>"{from}"</strong>
          to <strong>"{to}"</strong>
        </li>
      ))}
      <li>
        <Link
          to={`/customer/${obj1.customer_id || changelog.record_id}`}
          className="text-sm underline text-blue-700"
        >
          View record
        </Link>
      </li>
    </ul>
  );
};
